export default __webpack_public_path__ + "images/78.27b6cba.png";